// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"24efc592","61":"01fd51aa","233":"2e69b501","294":"c81a0253","356":"fc6091b8","709":"dfa49b6e","806":"df9f1e08"}[chunkId] + ".chunk.js";
};